$(document).ready(function(){
    $('.mega-menu').on("mouseover", function(){
        $(this).attr('open', '');
        console.log($(this));
    });
    $('.mega-menu').on("mouseout", function(){
        $(this).removeAttr('open');
    });
    $('.mega-menu .header__menu-item').on("click", function(e){
        e.preventDefault();
    })
}); 